import React from 'react';
import PropTypes from 'prop-types';
import UnsupportedDeviceBanner from './UnsupportedDeviceBanner';
import UnsyncedDataBanner from './UnsyncedDataBanner';
import SyncSuccessBanner from './SyncSuccessBanner';
import UnsupportedBrowserBanner from './UnsupportedBrowserBanner';

const BannersContainer = ({
    isDeviceSupported,
    isUnsyncedData,
    isSyncSuccess,
    isBrowserSupported,
}) => (
    <div className='dashboard-banners-container'>
        {!isDeviceSupported && <UnsupportedDeviceBanner />}

        {!isBrowserSupported && <UnsupportedBrowserBanner />}

        {isUnsyncedData && <UnsyncedDataBanner />}

        {isSyncSuccess && <SyncSuccessBanner />}
    </div>
);

BannersContainer.propTypes = {
    isDeviceSupported: PropTypes.bool,
    isUnsyncedData: PropTypes.bool,
    isSyncSuccess: PropTypes.bool,
    isBrowserSupported: PropTypes.bool,
};

BannersContainer.defaultProps = {
    isDeviceSupported: true,
    isBrowserSupported: true,
    isUnsyncedData: false,
    isSyncSuccess: false,
};

export default BannersContainer;
